import React from 'react';
import './Legal.css';

const PrivacyPolicy = () => {
    return (
        <div className="legal-container">
            <div className="legal-content">
                <h1>Privacy Policy – Echonote</h1>
                
                <h2>Introduction</h2>
                <p>
                    This Privacy Policy describes how Echonote ("we", "us", "our") collects, uses, shares, and protects your information when you use the Service. By using Echonote, you consent to this Privacy Policy.
                </p>

                <h2>1. Information We Collect</h2>
                <p>We collect the following information:</p>
                <p><strong>Personal Information:</strong> Name, email address, payment details (processed by Stripe).</p>
                <p><strong>Voice Data:</strong> Audio files you record and upload to the Service.</p>
                <p><strong>Generated Notes:</strong> Transcripts and notes produced from your audio.</p>
                <p><strong>Usage Data:</strong> Information about your interactions with the Service (pages visited, actions taken, etc.).</p>
                <p><strong>Analytics Data:</strong> Usage data collected via Google Analytics, Facebook Pixel, and TikTok Pixel.</p>
                <p><strong>Authentication Data:</strong> Information from third-party login providers (e.g., Google).</p>

                <h2>2. How We Use Your Information</h2>
                <p>We use collected information to:</p>
                <ul>
                    <li>Provide and operate the Service.</li>
                    <li>Convert audio files into written notes and other outputs using AI.</li>
                    <li>Maintain, improve, and personalize the Service.</li>
                    <li>Process transactions and manage your account.</li>
                    <li>Analyze Service usage via analytics tools.</li>
                    <li>Communicate with you about updates, promotions, or support.</li>
                </ul>

                <h2>3. Data Processing and Third-Party Sharing</h2>
                <p><strong>AI Providers:</strong> Your audio files and their transcripts are sent to OpenAI for processing (see OpenAI's Privacy Policy).</p>
                <p><strong>Payment Processor:</strong> Stripe handles all payment transactions. Echonote does not store payment details.</p>
                <p><strong>Analytics Providers:</strong> Google Analytics, Facebook Pixel, and TikTok Pixel collect anonymous usage data to help us improve the Service.</p>
                <p><strong>Service Providers:</strong> We may share data with trusted partners and service providers who assist us in operating the Service, strictly as needed.</p>
                <p><strong>Legal Compliance:</strong> We may disclose your information if required by law or in response to lawful requests by public authorities.</p>

                <h2>4. Data Security</h2>
                <p>
                    We use reasonable technical and organizational measures to protect your data. However, no method of transmission over the internet or electronic storage is completely secure.
                </p>

                <h2>5. Data Retention</h2>
                <p>
                    We retain your data as long as your account is active or as necessary to provide the Service. You may delete your account and all associated data at any time. Upon deletion, your data is permanently erased from our systems.
                </p>

                <h2>6. User Rights</h2>
                <p>You have the right to:</p>
                <ul>
                    <li>Access, correct, or update your personal information.</li>
                    <li>Delete your account and all associated data.</li>
                    <li>Unsubscribe from marketing emails at any time.</li>
                </ul>
                <p>
                    To exercise these rights, please contact us at <a href="mailto:contact@echonote.xyz">contact@echonote.xyz</a>.
                </p>

                <h2>7. Children's Privacy</h2>
                <p>
                    Echonote is not intended for children under 16 years old. We do not knowingly collect data from children under this age.
                </p>

                <h2>8. Changes to This Policy</h2>
                <p>
                    We may update this Privacy Policy from time to time. Updates will be posted on our website. Your continued use of the Service after changes means you accept the updated Policy.
                </p>

                <h2>Contact</h2>
                <p>
                    For any questions about this Privacy Policy, please contact us at <a href="mailto:contact@echonote.xyz">contact@echonote.xyz</a>.
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy; 